<div
  data-slot="empty"
  class="empty"
  [ngClass]="className"
>
  <ng-content></ng-content>
</div>
